const searchUserResponseAdapter = (account, profile) => {
  if (!account || !profile) return null;

  return {
    first_name: account.firstName || "",
    last_name: account.lastName || "",
    uam_id: profile.uamId || "",
    phone: account.phone || "",
    admission_number: profile.admissionId || "",
    grade_id: account.gradeId || "",
    crn_id: profile.crnId || "",
  };
};

export default searchUserResponseAdapter;
